import { ReactNode } from 'react';

import { SessionWarningModal } from 'components/feedback/SessionWarningModal';

import {
  SESSION_TIMEOUT,
  WARNING_DURATION,
  useSessionManager,
} from 'hooks/utils/useSessionManager';

import { useAuthStore } from 'store/index';

interface SessionProviderProps {
  children: ReactNode;
}

export const SessionProvider = ({ children }: SessionProviderProps) => {
  const { user } = useAuthStore();

  const {
    showWarningModal,
    handleExtendSession,
    handleWarningLogout,
    getTimeUntilExpiry,
  } = useSessionManager({
    timeoutDuration: SESSION_TIMEOUT,
    enableActivityMonitoring: true,
    enableWarning: true,
    warningDuration: WARNING_DURATION,
  });

  // Only show session management when user is authenticated
  if (!user) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      <SessionWarningModal
        isVisible={showWarningModal}
        timeRemaining={getTimeUntilExpiry()}
        onExtendSession={handleExtendSession}
        onLogout={handleWarningLogout}
      />
    </>
  );
};
